import styled from "styled-components";
import { verificationProgressConfig } from "../config/setting-form";

export function VerificationSteps({ currentStep }: { currentStep: number }) {
  return (
    <VerificationStepsContainer>
      {verificationProgressConfig.map((item, index) => {
        return (
          <VerificationStepsProgressItem
            isLastItem={index === verificationProgressConfig.length - 1}
            isActive={currentStep >= index}
          >
            <VerificationStepsProgressIcon isActive={currentStep >= index}>
              {index + 1}
            </VerificationStepsProgressIcon>
            {item}
          </VerificationStepsProgressItem>
        );
      })}
    </VerificationStepsContainer>
  );
}

const VerificationStepsContainer = styled.div`
  padding: 32px 62px;
  display: flex;
  justify-content: space-between;
`;
const VerificationStepsProgressIcon = styled.div<{ isActive: boolean }>`
  border-radius: 50%;
  width: 18px;
  height: 18px;
  background: ${(p) => (p.isActive ? "#13CB75" : "#AAB5B9")};
  color: ${(p) => (p.isActive ? "#ffffff" : "#343538")};
  text-align: center;
  margin-right: 6px;
  font-size: 14px;
`;
const VerificationStepsProgressItem = styled.div<{
  isLastItem: boolean;
  isActive: boolean;
}>`
  position: relative;
  display: flex;
  font-weight: ${(p) => (p.isActive ? 600 : 400)};
  color: ${(p) => (p.isActive ? "#ffffff" : "#AAB5B9")};
  font-size: 16px;
  align-items: center;
  &::after {
    content: "";
    width: 40px;
    position: absolute;
    right: -52px;
    height: 1px;
    top: 11px;
    background: ${(p) => (p.isActive ? "#EDF2F5" : "#AAB5B9")};
    display: ${(p) => p.isLastItem && "none"};
  }
`;
